import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetWorkerRequestSchema,
  TGetWorkerResponseSchema,
} from "./getWorker.schema";

export const getWorker = (axios: IAxiosInstance) => {
  return async (query: TGetWorkerRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetWorkerResponseSchema>
    >(`/api/workers`, {
      params: query,
    });

    const resData = response.data;

    return resData;
  };
};
